// Readium file:// protocol patches — IMPORTANT: this module has side effects.
// Importing it mutates `Link.prototype.toURL` and `window.Blob`.
//
// Readium was designed for HTTP-served publications and strips "file://"
// from resolved URLs in two places that break local (file://) publications:
//
// 1. Link.toURL() strips file:// from the result (Link.ts line 166),
//    breaking blob-iframe <base> tags and fetch() calls.
// 2. FrameBlobBuilder injects a CSP meta tag using pub.baseURL as a source,
//    but file:///path is not a valid CSP source — browsers reject it,
//    blocking fonts/images in EPUB content frames.

import { Link } from '@readium/shared';

// Patch 1: Preserve file:// in Link.toURL() when the base URL is file://.
const _originalLinkToURL = Link.prototype.toURL;
Link.prototype.toURL = function (baseUrl) {
    const result = _originalLinkToURL.call(this, baseUrl);
    if (result && baseUrl?.startsWith('file://') && !result.startsWith('file://')) {
        return `file://${result}`;
    }
    return result;
};

// Patch 2: Fix CSP in Readium's XHTML blobs — replace invalid file:///path
// sources with the valid file: scheme source so the browser allows loading
// local fonts, images, and other resources inside content iframes.
const _OriginalBlob = window.Blob;
const _cspMetaRe = /(http-equiv="Content-Security-Policy"[^>]*content=")(.*?)(")/;
const _fileUrlSourceRe = /file:\/\/\/[^\s;"]+/g;
window.Blob = class extends _OriginalBlob {
    constructor(parts, options) {
        if (
            options?.type?.includes('html') &&
            typeof parts?.[0] === 'string' &&
            parts[0].includes('data-readium="true"') &&
            parts[0].includes('file:///')
        ) {
            parts = [
                parts[0].replace(
                    _cspMetaRe,
                    (_, pre, csp, post) => pre + csp.replace(_fileUrlSourceRe, 'file:') + post
                ),
            ];
        }
        super(parts, options);
    }
};

// file:// fetch client shared across all DecryptingHttpFetcher instances.
// Normalizes status 0 responses (returned by fetch for file:// URLs) to
// status 200 so Readium's HttpResource resp.ok check passes.
export const fileClient = async (input, init) => {
    const resp = await fetch(input, init);
    if (resp.status === 0) {
        return new Response(resp.body, {
            status: 200,
            statusText: 'OK',
            headers: resp.headers,
        });
    }
    return resp;
};
